// Local mode helper - skips Firestore calls when in local-only mode
export const isLocalMode = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return localStorage.getItem('dbMode') !== 'firebase';
  } catch {
    return false;
  }
};

export const hasFirebaseConfig = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const apiKey = localStorage.getItem('firebase_api_key');
    return !!apiKey && apiKey !== 'demo-key-maint-system' && apiKey !== '';
  } catch {
    return false;
  }
};

export const isFirebaseReady = (): boolean => {
  return hasFirebaseConfig() && !isLocalMode();
};

// LocalStorage helpers with safe parsing
export const getLocalList = <T = any>(key: string): T[] => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const setLocalList = <T = any>(key: string, list: T[]): void => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(key, JSON.stringify(list));
  } catch (error) {
    console.error(`Error saving to localStorage[${key}]:`, error);
  }
};

export const getLocalObject = <T = any>(key: string): T | null => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
};

export const setLocalObject = <T = any>(key: string, value: T): void => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error saving to localStorage[${key}]:`, error);
  }
};

export const generateLocalId = (prefix: string = 'local'): string => {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
};
